var POPUP_STACK = [];

function hidePopupByName(name) {
  const popup = document.getElementById('popup-query-' + name);
  hidePopup(popup);
}
window.hidePopupByName = hidePopupByName;

function hidePopup(popup) {
  popup = popup.closest('.popup-query-bg');
  popup.classList.add('hidden');
  const idx = POPUP_STACK.indexOf(popup);
  if (idx >= 0) POPUP_STACK.splice(idx, 1);

  if (POPUP_STACK.length) {
    POPUP_STACK[POPUP_STACK.length - 1].classList.remove('hidden');
  }
}
window.hidePopup = hidePopup;

function unhidePopup(popup) {
  popup = popup.closest('.popup-query-bg');
  for (const other of POPUP_STACK) {
    other.classList.add('hidden');
  }
  popup.classList.remove('hidden');
  POPUP_STACK.push(popup);
}
window.unhidePopup = unhidePopup;

/**
 * This function displays a popup or "modal" to the user. It is necessary to render this snippet
 * on the page where this function is to be used.
 *
 * name (String) - The name of the popup, and the suffix of the element ID.
 * data (object) - The data object passed into the onConfirm and onCancel callbacks.
 * headerText (String) - Text to be injected into the header of the popup.
 * bodyHtml (String) - raw HTML to be injected into the body of the popup.
 * onConfirm (function) - Callback function triggered when user clicks "confirm"
 * onCancel (function) - Callback function triggered when user clicks "cancel"
 * isNotification (Boolean: false) - Boolean 'true' if this is a simple notification, hides the 'Cancel' button.
 * enableConfirm (Boolean: true) - Boolean 'false' disables the 'Confirm' button on display.
 * critical (Boolean: false) - Boolean 'true' applies special styling to the "confirm" button.
 * confirmText (String: 'Confirm') - Text to be injected to the body of the "Confirm" button.
 * cancelText (String: 'Cancel') - Text to be injected to the body of the "Cancel" button.
 * hideClose (Boolean: false) - hide the X button in top right of modal
 * onlyHideIfonConfirmReturnsTrue (Boolean: false) - Only close modal if onConfirm returns true
 *
 */
function showPopupQuery({
  name,
  data,
  headerText,
  bodyHtml,
  onConfirm,
  onCancel,
  isNotification = false,
  enableConfirm = true,
  critical = false,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  hideClose = false,
  onlyHideIfonConfirmReturnsTrue = false,
}) {
  const popup = document.getElementById('popup-query-' + name);
  hidePopup(popup);
  const header = popup.querySelector('div.popup-query-header > :first-child');
  const body = popup.querySelector('div.popup-query-card .popup-query-body');
  const cancel = popup.querySelector('button.popup-query-cancel');
  const confirm = popup.querySelector('button.popup-query-confirm');
  if (cancelText) cancel.innerText = cancelText;
  cancel.style.visibility = isNotification ? 'hidden' : 'inherit';
  if (onCancel) {
    const cancelClick = function () {
      hidePopup(popup);
      onCancel(data);
    };
    cancel.onclick = cancelClick;
    popup.querySelector('div.popup-query-header div.popup-query-x').onclick = cancelClick;
  }
  if (hideClose) {
    popup.querySelector('div.popup-query-header div.popup-query-x').style.display = 'none';
  }
  if (confirm) {
    if (confirmText) confirm.innerText = confirmText;
    confirm.disabled = !enableConfirm;
    if (critical) confirm.classList.add('critical-button');
    else confirm.classList.remove('critical-button');
    confirm.onclick = function () {
      if (!onlyHideIfonConfirmReturnsTrue) {
        hidePopup(popup);
      }
      if (onConfirm) {
        if (onConfirm(data) === true) {
          // if the onConfirm function returns false, do not close modal
          hidePopup(popup);
        }
      }
    };
  }
  if (headerText) header.innerHTML = headerText;
  if (bodyHtml) {
    while (body.firstChild) {
      body.removeChild(body.firstChild);
    }
    body.innerHTML = bodyHtml;
    let inputs = body.querySelectorAll('input');
    if (inputs.length) {
      inputs[0].focus();
      inputs.forEach(input => {
        input.addEventListener('keypress', event => {
          if (event.key === 'Enter') {
            event.preventDefault();
            confirm.click();
          }
        });
      });
    }
  }

  unhidePopup(popup);
  return { popup, header, body, cancel, confirm };
}
window.showPopupQuery = showPopupQuery;
